import { takeEvery, put } from 'redux-saga/effects';
import { consts as editAvatarConsts } from './edit-avatar';
import { consts as editUserConsts } from './edit-user';

function* updateAvatarWorker(action) {
  yield put({
    type: editUserConsts.SUCCEED,
    payload: action.payload,
  });
}

export function* updateAvatarSaga() {
  yield takeEvery([editAvatarConsts.SUCCEED], updateAvatarWorker);
}



// WEBPACK FOOTER //
// ./src/redux/profiles/updateAvatarSaga.js